import React from 'react';
type SweepLoaderProps = {
  className?: string;
  label?: string;
};

/** Loading state: a sweeping second hand inside a hairline dial. */
export function SweepLoader({
  className = 'h-4 w-4',
  label = 'Loading'
}: SweepLoaderProps) {
  return <svg viewBox="0 0 24 24" className={className} role="status" aria-label={label} data-id="element-446" data-mp="2sn89lq9xrdx1">
      <circle cx="12" cy="12" r="10.5" fill="none" stroke="currentColor" strokeOpacity="0.4" strokeWidth="1" data-id="element-447" data-mp="2wnindp3yz8mg" />
      <g className="tt-sweep" data-id="element-448" data-mp="2inzhz42jmbdu">
        <line x1="12" y1="13.5" x2="12" y2="3.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-449" data-mp="2nodnofgo998p" />
      </g>
      <circle cx="12" cy="12" r="1.3" fill="currentColor" data-id="element-450" data-mp="29pe2xiwa5eht" />
    </svg>;
}